import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../assets/icons/download-arrow.svg'
import _imports_1 from '../../../assets/icons/filter.svg'
import _imports_2 from '../../../assets/icons/filter-light.svg'


const _hoisted_1 = {
  "data-testid": "list-members-page",
  class: "page list-members-page"
}
const _hoisted_2 = {
  ref: "filterPanel",
  class: "page-filters-wrapper"
}
const _hoisted_3 = ["threshold"]
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = {
  key: 0,
  class: "pl-1 grey--text text--darken-1"
}
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = {
  class: "elevation-10 pa-3",
  style: {"background-color":"#fff"}
}
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = {
  class: "elevation-10 pa-3",
  style: {"background-color":"#fff"}
}
const _hoisted_10 = { class: "ml-2" }
const _hoisted_11 = {
  key: 1,
  class: "d-flex align-center justify-center text-center"
}
const _hoisted_12 = { class: "pa-10" }
const _hoisted_13 = {
  key: 2,
  class: "d-flex align-center justify-center pt-5 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Watermark = _resolveComponent("Watermark")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_KeyStats = _resolveComponent("KeyStats")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_SortingPanel = _resolveComponent("SortingPanel")!
  const _component_FilterTable = _resolveComponent("FilterTable")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Watermark, { isSampleReport: _ctx.isBenchmarkUser }, null, 8, ["isSampleReport"]),
    _createVNode(_component_v_container, {
      fluid: "",
      class: "pos-relative"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_snackbar, {
          modelValue: _ctx.noDataAlert,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.noDataAlert) = $event)),
          timeout: 80000,
          color: "primary",
          location: "top"
        }, {
          default: _withCtx(() => [
            _cache[18] || (_cache[18] = _createElementVNode("h3", null, "No data available for this provider", -1)),
            _createVNode(_component_v_btn, {
              color: "blue",
              variant: "text",
              class: "d-flex ml-auto",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.noDataAlert = false))
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode(" Close ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_KeyStats, {
          class: "my-4 mb-10",
          data: _ctx.metrics,
          "selection-count": _ctx.selectedItems ? _ctx.selectedItems.length : 0,
          "total-count": _ctx.memberAnalysis ? _ctx.memberAnalysis.length : 0
        }, null, 8, ["data", "selection-count", "total-count"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            threshold: _ctx.filterPanelPosition,
            id: "navbar",
            class: _normalizeClass(["navbar page-filters-panel pos-relative justify-space-between pa-2", _ctx.scrolledAll ? 'vue-fixed-header--isFixed' : ''])
          }, [
            _createVNode(_component_v_layout, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "my-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "4",
                      "align-self": "center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", _hoisted_4, [
                          _cache[19] || (_cache[19] = _createElementVNode("span", null, "ALL SAVERS", -1)),
                          (_ctx.selectedItems && _ctx.selectedItems.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString(_ctx.selectedItems.length) + " out of " + _toDisplayString(_ctx.memberAnalysis.length) + " selected)", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    (!_ctx.isBenchmarkUser)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          class: "d-flex justify-end py-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.outlierIsVisible,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.outlierIsVisible) = $event)),
                              "close-on-content-click": false,
                              attach: ".page-filters-wrapper",
                              left: "",
                              "max-width": "300px",
                              "content-class": "filter-menu_buttons",
                              offset: 20,
                              transition: "slide-y-transition"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps({
                                  disabled: _ctx.fetchingMembersAnalysis && !_ctx.memberAnalysis,
                                  class: "outlier-btn elevation-4 mt-0 mx-2",
                                  "data-testid": "OutlierBtn"
                                }, props, {
                                  variant: "text",
                                  size: "small"
                                }), {
                                  default: _withCtx(() => [
                                    _cache[20] || (_cache[20] = _createElementVNode("span", null, "Outliers", -1)),
                                    _createElementVNode("div", _hoisted_6, [
                                      _createVNode(_component_v_img, {
                                        class: "filter-icon",
                                        src: _imports_0
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }, 16, ["disabled"])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                  _createVNode(_component_v_select, {
                                    modelValue: _ctx.outlierProvider,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.outlierProvider) = $event)),
                                    "item-title": "name",
                                    "item-value": "id",
                                    items: _ctx.providers,
                                    placeholder: "Select Provider",
                                    "hide-details": "",
                                    color: "primary",
                                    density: "compact",
                                    variant: "outlined"
                                  }, null, 8, ["modelValue", "items"]),
                                  _createVNode(_component_v_divider),
                                  _createVNode(_component_v_btn, {
                                    variant: "text",
                                    left: "",
                                    width: "100%",
                                    class: "mt-3",
                                    disabled: !_ctx.outlierProvider,
                                    loading: _ctx.fetchingOutliers,
                                    onClick: _ctx.fetchOutliers
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        small: "",
                                        class: "mr-3"
                                      }, {
                                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                          _createTextVNode("fas fas fa-eye", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[22] || (_cache[22] = _createTextVNode("Show ", -1))
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "loading", "onClick"])
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.downloadIsVisible,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.downloadIsVisible) = $event)),
                              "close-on-content-click": false,
                              attach: ".page-filters-wrapper",
                              left: "",
                              "max-width": "300px",
                              "min-width": "150px",
                              offset: "20",
                              transition: "slide-y-transition"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps({
                                  class: ["csv-btn elevation-4 mt-0 mx-2", { 'is-active': _ctx.sortingIsApplied }],
                                  disabled: _ctx.fetchingMembersAnalysis && !_ctx.memberAnalysis,
                                  "data-testid": "SortingBtn"
                                }, props, {
                                  variant: "text",
                                  size: "small"
                                }), {
                                  default: _withCtx(() => [
                                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "DOWNLOAD", -1)),
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(_component_v_img, {
                                        class: "filter-icon",
                                        src: _imports_0
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }, 16, ["class", "disabled"])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_v_select, {
                                      modelValue: _ctx.memberCSVProviders,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.memberCSVProviders) = $event)),
                                      "item-title": "name",
                                      "item-value": "id",
                                      items: _ctx.providers,
                                      placeholder: "Select Provider",
                                      "hide-details": "",
                                      color: "primary",
                                      density: "compact",
                                      variant: "outlined"
                                    }, null, 8, ["modelValue", "items"]),
                                    _createVNode(_component_v_divider),
                                    _createVNode(_component_v_btn, {
                                      variant: "text",
                                      width: "100%",
                                      class: "mt-3",
                                      disabled: !_ctx.memberCSVProviders,
                                      loading: _ctx.processingCSV,
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportCSV(true)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          small: "",
                                          class: "mr-3"
                                        }, {
                                          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                            _createTextVNode("fas fa-file-download", -1)
                                          ]))]),
                                          _: 1
                                        }),
                                        _cache[25] || (_cache[25] = _createTextVNode("Download All ", -1))
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "loading"])
                                  ]),
                                  _createVNode(_component_v_divider, { class: "my-2" }),
                                  _createVNode(_component_v_btn, {
                                    variant: "text",
                                    width: "100%",
                                    class: "pa-2",
                                    loading: _ctx.processingCurrentCSV,
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportCSV(false)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        small: "",
                                        class: "mr-3"
                                      }, {
                                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                          _createTextVNode("fas fa-file-download", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[27] || (_cache[27] = _createTextVNode("Download Current View ", -1))
                                    ]),
                                    _: 1
                                  }, 8, ["loading"])
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.sortingIsVisible,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sortingIsVisible) = $event)),
                              "close-on-content-click": false,
                              attach: ".page-filters-wrapper",
                              left: "",
                              "max-width": "300px",
                              "min-width": "150px",
                              offset: "20",
                              transition: "slide-y-transition"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps({
                                  class: ["sorting-btn elevation-6 mt-0 mx-2", { 'is-active': _ctx.sortingIsApplied }],
                                  disabled: _ctx.fetchingMembersAnalysis && !_ctx.memberAnalysis,
                                  "data-testid": "SortingBtn"
                                }, props, {
                                  variant: "text",
                                  size: "small"
                                }), {
                                  default: _withCtx(() => [
                                    _cache[29] || (_cache[29] = _createElementVNode("span", null, "Sort", -1)),
                                    _createVNode(_component_v_icon, {
                                      small: "",
                                      right: "",
                                      class: "ml-2"
                                    }, {
                                      default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                        _createTextVNode("fas fa-sort-amount-down-alt", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 16, ["class", "disabled"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_SortingPanel, {
                                  items: _ctx.sortByItems,
                                  "default-sorting": _ctx.defaultSorting,
                                  onReset: _ctx.resetSorting,
                                  isSortingApplied: _ctx.isSortingApplied,
                                  onApply: _ctx.applySorting
                                }, null, 8, ["items", "default-sorting", "onReset", "isSortingApplied", "onApply"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.filterIsVisible,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filterIsVisible) = $event)),
                              "close-on-content-click": false,
                              attach: ".page-filters-wrapper",
                              "content-class": "page-filter-main",
                              "max-width": "100%",
                              "min-width": "100%",
                              offset: "20",
                              transition: "slide-y-transition"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps({
                                  class: ["filter-btn elevation-6 mt-0 mx-2", { 'is-active': _ctx.filtersAreApplied }],
                                  disabled: _ctx.fetchingMembersAnalysis && !_ctx.memberAnalysis,
                                  "data-testid": "FilterBtn",
                                  variant: "text"
                                }, props, { size: "small" }), {
                                  default: _withCtx(() => [
                                    _cache[30] || (_cache[30] = _createElementVNode("span", null, "Filter", -1)),
                                    _createElementVNode("div", _hoisted_10, [
                                      (!_ctx.filtersAreApplied)
                                        ? (_openBlock(), _createBlock(_component_v_img, {
                                            key: 0,
                                            class: "filter-icon",
                                            src: _imports_1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.filtersAreApplied)
                                        ? (_openBlock(), _createBlock(_component_v_img, {
                                            key: 1,
                                            class: "filter-icon",
                                            src: _imports_2
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }, 16, ["class", "disabled"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_FilterTable, {
                                  dateFilters: true,
                                  showProviderFilters: true,
                                  filters: _ctx.filters,
                                  appliedFiltersParent: _ctx.appliedFilters,
                                  onApply: _cache[9] || (_cache[9] = (e) => _ctx.onFiltersApplied(e))
                                }, null, 8, ["filters", "appliedFiltersParent"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 10, _hoisted_3)
        ], 512),
        (_ctx.outlierData && !_ctx.fetchingOutliers && _ctx.outlierProviderName)
          ? (_openBlock(), _createBlock(_component_v_dialog, {
              key: 0,
              modelValue: _ctx.outliersDialog,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.outliersDialog) = $event)),
              "onClick:outside": _cache[14] || (_cache[14] = ($event: any) => (_ctx.outliersDialog = false)),
              persistent: "",
              "max-width": "80vw",
              "max-height": "90%"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "pa-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _cache[31] || (_cache[31] = _createTextVNode(" Outliers of Provider #", -1)),
                            _createElementVNode("b", null, _toDisplayString(_ctx.outlierProviderName), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("small", null, " Suspect data : " + _toDisplayString(_ctx.outlierSuspectCount) + "% ", 1),
                            _cache[32] || (_cache[32] = _createTextVNode()),
                            _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("small", null, " Short Contribution History : " + _toDisplayString(_ctx.outlierShortCont) + "% ", 1),
                            _cache[34] || (_cache[34] = _createTextVNode()),
                            _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("small", null, " 0 NAV : " + _toDisplayString(_ctx.outlierNAVCount) + "% ", 1)
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_btn, {
                            left: "",
                            color: "primary",
                            class: "mr-4",
                            disabled: !_ctx.outlierProvider,
                            loading: _ctx.processingOutlier,
                            onClick: _ctx.exportOutlierCSV
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                small: "",
                                class: "mr-3"
                              }, {
                                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                  _createTextVNode("fas fa-file-download", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[37] || (_cache[37] = _createTextVNode("Download ", -1))
                            ]),
                            _: 1
                          }, 8, ["disabled", "loading", "onClick"]),
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            small: "",
                            variant: "flat",
                            icon: "",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.outliersDialog = false))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { small: "" }, {
                                default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                  _createTextVNode("fa fa-times", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_AppTable, {
                          "table-data": _ctx.outliersTableData,
                          disableSort: true,
                          disablePagination: true,
                          "default-sort-column": [{ key: 'potSize', order: 'asc' }]
                        }, null, 8, ["table-data"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          color: "grey-darken-1",
                          variant: "text",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.outliersDialog = false))
                        }, {
                          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                            _createTextVNode("Close", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (!_ctx.fetchingMembersAnalysis || _ctx.memberAnalysis)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 1,
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                (_ctx.memberAnalysis && _ctx.memberAnalysis.length)
                  ? (_openBlock(), _createBlock(_component_AppTable, {
                      key: 0,
                      "table-data": _ctx.tableData,
                      pagination: _ctx.paginateOptions,
                      "show-select": true,
                      "hide-actions": false,
                      loading: _ctx.fetchingMembersAnalysis,
                      "disable-sort": true,
                      striped: true,
                      onPage: _ctx.onPageChange,
                      disablePagination: _ctx.isBenchmarkUser,
                      onItemsPerPage: _ctx.onItemsPerPageChange
                    }, null, 8, ["table-data", "pagination", "loading", "onPage", "disablePagination", "onItemsPerPage"]))
                  : _createCommentVNode("", true),
                (!_ctx.memberAnalysis || !_ctx.memberAnalysis.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                            _createTextVNode("fa fa-box", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[41] || (_cache[41] = _createElementVNode("h2", { class: "heading" }, "No data available.", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.fetchingMembersAnalysis && !_ctx.memberAnalysis)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "grey"
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.fetchingOutliers)
          ? (_openBlock(), _createBlock(_component_AppLoader, { key: 3 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.pdfTimeoutError,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.pdfTimeoutError) = $event)),
      timeout: 3000,
      color: "primary",
      location: "top"
    }, {
      default: _withCtx(() => [
        _cache[43] || (_cache[43] = _createElementVNode("h3", null, "Error downloading requested pdf. Please try again.", -1)),
        _createVNode(_component_v_btn, {
          color: "blue",
          variant: "text",
          class: "d-flex ml-auto",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.pdfTimeoutError = false))
        }, {
          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}